import { render, staticRenderFns } from "./AProduct.vue?vue&type=template&id=66a58660&scoped=true&"
import script from "./AProduct.vue?vue&type=script&lang=js&"
export * from "./AProduct.vue?vue&type=script&lang=js&"
import style0 from "./AProduct.vue?vue&type=style&index=0&id=66a58660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a58660",
  null
  
)

export default component.exports